import { ALERT_SELECT } from '../actionTypes/index';
const initialState = {
    alert: false
}
const alertSelect = (state = initialState, action) => {
    switch (action && action.type) {
        case ALERT_SELECT:
            return {
                ...state,
                alert: action.payload
            }
        default:
            return state;
    }
}

export default alertSelect;